import NotFoundPage from "./pages/NotFound";
import ClinicManager from "./pages/admin/ClinicManager";
import AdminLogin from "./pages/AdminLogin";
import RequireAuth from "./auth/RequireAuth";
import RedirectIfAuth from "./auth/RedirectIfAuth";
import ProtectedRoute from "./auth/ProtectedRoute";

import SchedulePage from "./pages/admin/SchedulePage";
import ActivityLog from "./pages/admin/ActivityLog";
import DoctorManager from "./pages/admin/DoctorManager";
import UserListPage from "./pages/admin/UserList";
import DashboardPage from "./pages/admin/Dashboard";
import Appointment from "./pages/admin/Appointment";
import OrganizationList from "./pages/admin/OrganizationList";
import { Perm, Roles } from "./auth/permissions";
import RoleListPage from "./pages/admin/RoleListPage";
import AppointmentRequestManagement from "./pages/admin/AppointmentRequestManagement";

const protectedRoutes = [
  {
    path: "clinic",
    element: <ClinicManager />,
    requiredPerms: [],
  },
  {
    path: "schedule",
    element: <SchedulePage />,
    requiredPerms: [],
  },
  {
    path: "bac-si",
    element: <DoctorManager />,
    requiredPerms: [],
  },
  {
    path: "appointment",
    element: <Appointment />,
    requiredPerms: [Perm.Appointment_View],
  },
  {
    path: "appointment/request",
    element: <AppointmentRequestManagement />,
    requiredPerms: [Perm.Appointment_Request_Manage],
  },
  {
    path: "activity-log",
    element: <ActivityLog />,
    requiredPerms: [Perm.Report_Log],
  },
  {
    path: "users",
    element: <UserListPage />,
    requiredPerms: [Perm.User_View],
  },
  {
    path: "dashboard",
    element: <DashboardPage />,
    requiredPerms: [Perm.Report_View],
  },
  {
    path: "organization",
    element: <OrganizationList />,
    reqiredPerms: [Perm.Organization_View],
  },
  {
    path: "roles",
    element: <RoleListPage />,
    requiredRoles: [Roles.Admin],
  }
];

const AdminRoutes = [
  {
    path: "login",
    element: (
      <RedirectIfAuth to="/schedule">
        <AdminLogin />
      </RedirectIfAuth>
    ),
  },
  ...protectedRoutes.map(({ element, requiredPerms, requiredRoles, ...route }) => ({
    ...route,
    element: (
      <RequireAuth>
        <ProtectedRoute requiredPerms={requiredPerms} requiredRoles={requiredRoles}>{element}</ProtectedRoute>
      </RequireAuth>
    ),
  })),
  { 
    path: "*",
    element: <NotFoundPage />,
  },
];

export default AdminRoutes;
